<div class="small-popup">
  <div class="modal-body p-0">
    <div class="modal-header">@if (modalObj?.closeBtn) {
      <span class="close icon-cross"
      (click)="activeModal.dismiss(false)"></span>
    }
    <h6 class="text-white">Become a Financial Advisor</h6>
  </div>
  <div class="p-3">
    <div class="img-bg my-3 text-center w-100">
      <!-- <h6 class="text-white">Are you sure you want to proceed with the purchase of this service for ₹299 (inclusive of GST)?</h6> -->

      <!-- <img *ngIf="modalObj?.success" width="20%" [src]="modalObj?.success" class="text-success">
      <img *ngIf="modalObj?.error" width="20%" [src]="modalObj?.error" class=" text-danger">
      <img *ngIf="modalObj?.img" [src]="modalObj.img" alt="e-kyc"> -->
      <div class="info-section">
        <div class="info-text primary-text text-center">
          Are you sure you want to become a Financial Advisor?
        </div>
        <div class="info-text secondary-text text-center">
          ₹2,499 (including GST). will be deducted from your account.
        </div>
        <h6>Balance Type</h6>
        <div class="form-group radio-box d-flex justify-content-center my-3">

          @if (walletData?.length != 0) {
            <div class="radio-box-wrap">
              @for (item of walletData?.wallet; track item; let i = $index) {
                <div class="form-check form-check-inline mr-4"
                  >
                  <input [formControl]="wallet_type" [checked]="item?.name === 'main'"
                    class="form-check-input" type="radio" name="wallet_type" id="{{'wallet_type'+i}}"
                    [value]="item" />
                    <label class="form-check-label text-uppercase" [for]="'wallet_type' + i"> {{item?.name}}
                      <span class="text-danger">₹ {{ item?.balance }}</span></label>
                    </div>
                  }
                </div>
              }

            </div>
          </div>

        </div>
        <div class="col-12 p-0 text-center">
          <button type="button" class="btn btn-danger-outline mr-3 " (click)="closeModal()">Cancel</button>
          <button type="button" class="btn btn-primary mr-3 text-capitalize" (click)="onboard()">Confirm</button>


        </div>
      </div>
    </div>
  </div>